import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from 'src/environments/environment';
import { Response } from '@shared/interfaces/response/response';
import { Tasas } from '@p-p-portafolio/interfaces/tasas';

const httpOption = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  }),
};

@Injectable({ providedIn: 'root' })
export class TasasService {
  private _url = environment.apiBaseUrl + 'api/parametria/portafolio/tasas/';
  private _urlNew = environment.apiNewBackBaseUrl;

  constructor(private _http: HttpClient) {}

  create(model: Tasas): Observable<Response> {
    return this._http.post<Response>(this._url, model, httpOption);
  }

  read(): Observable<Response> {
    return this._http.get<Response>(this._url);
  }

  update(model: Tasas): Observable<Response> {
    return this._http.put<Response>(this._url, model, httpOption);
  }

  delete(model: Tasas): Observable<{success: boolean, data: [{error: string}]}> {
    const payload = {
      clave: model.clave,
      fechaInicia: model.fechaInicia,
      descripcion: model.descripcion,
      valor: model.valor
    };
    return this._http.post<{success: boolean, data: [{error: string}]}>(this._urlNew + 'CarteraGral/GetDltTasa', payload, httpOption);
  }

  readOne(clave: string): Observable<Response> {
    let url: string = this._url + clave;
    return this._http.get<Response>(url);
  }

  simulator(clave: string): Observable<Response> {
    let url: string = this._url + 'simulator/' + clave;
    return this._http.get<Response>(url);
  }

  historical(clave: string): Observable<Response> {
    let url: string = this._url + 'historical/' + clave;
    return this._http.get<Response>(url);
  }
}
